import { render, staticRenderFns } from "./base-action-list.vue?vue&type=template&id=15a4e5f0"
import script from "./base-action-list.vue?vue&type=script&setup=true&lang=js"
export * from "./base-action-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-action-list.vue?vue&type=style&index=0&id=15a4e5f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports